import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NavItemModel } from '../nav-items/models/nav-item.model';
import { NavItemType } from '../nav-items/models/nav-item-type.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-modal',
  templateUrl: './menu-modal.component.html',
})
export class MenuModalComponent implements OnInit {
  @Input() title?: string;
  @Input() items?: Array<NavItemModel>;
  @Input() toUpperCase = true;
  @Input() showProfile = false;
  @Output() signOutEmitter = new EventEmitter<void>();

  @ViewChild('modalTemplate') modalTemplate: any;

  modalRef!: NgbModalRef;
  navItemType = NavItemType;

  constructor(public modalService: NgbModal, private router: Router) {}

  ngOnInit(): void {}

  openModal() {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      windowClass: 'modal-custom-lg',
    });
  }

  isActive(navTo: string): boolean {
    return this.router.url.includes(navTo);
  }

  navigateTo(route: string) {
    if (this.isActive(route)) {
      this.modalRef.close();
      return;
    }
    this.modalRef.close();
    this.router.navigate([route]);
  }

  signOut() {
    this.modalRef.close();
    this.signOutEmitter.emit();
  }
}
